import NumberFieldBase from '../base/NumberField';
import createField from './createField';

const NumberField = createField(NumberFieldBase);

export default NumberField;
